import React from "react";

export const Disconnect = (props) => (
  <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.365 5.63989C19.8789 9.15491 19.8783 14.8529 16.3636 18.3671C12.849 21.8814 7.15102 21.8814 3.63639 18.3671C0.121746 14.8529 0.121126 9.15491 3.635 5.63989" stroke="#A2A2A2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="noFill"/>
    <path d="M10.0059 1V11" stroke="#A2A2A2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
